module.exports = __webpack_public_path__ + "static/media/profile_bg_mobile.74a5369c.png";